<template>
  <div id="manage">
    <div class="content">
        <div class="title">高教管理</div>
        <div class="botBox">
            <div class="bottomBox">
                <div class="selVox">
                    <div class="fl_left">
                        <input type="password"  autocomplete="new-password" style="display: none;">
                        <Input 
                        id="demo" 
                        v-model="searchModel.keyword" 
                        icon="ios-search" 
                        placeholder="姓名/联系电话/登录账号" 
                        style="width: 330px;height:34px;border:1px solid #e7e7eb;margin:20px 0;" 
                        class="bradius" 
                        @on-click="getTeacherList(1)" 
                        @keyup.enter.native="getTeacherList(1)" 
                        autocomplete="off"></Input>
                        <Select v-model="searchModel.level_id" clearable placeholder="请选择级别" class="borDiv" style="width:200px;border:1px solid #e7e7eb;margin:20px 0;" @on-change="getTeacherList(1)">
                            <Option v-for="item in levelArr" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                        <Select v-model="searchModel.grade_id" clearable placeholder="请选择等级" class="borDiv" style="width:200px;border:1px solid #e7e7eb;margin:20px 0;" @on-change="getTeacherList(1)">
                            <Option v-for="item in gradeList" :value="item.id" :key="item.id">{{ item.grade }}</Option>
                        </Select>
                    </div>
                    <div class="fl_right addClass" @click="addTeacher">新增高教</div>
                </div>
                <div class="bottom" style="border:1px solid #e6e6e6;box-sizing: border-box;">
                    <Table :columns="columns7" :data="data6" :loading="loading" :draggable="true" @on-drag-drop="setWorkSort"></Table>
                </div>
                <Page :page-size="pageSize" :total="total" show-total :current="searchModel.page" @on-change="updatePage" style="position:absolute;bottom:20px;left:38%;"></Page>
            </div>
            <div class="alertBox" v-if="alertShow" style="padding-top: 2%;">
                <div class="tanchuan" style="width: 710px;overflow: hidden;height:98%;position: relative;">
                    <div class="tantop">
                        <div class="fl_left tantitle">{{valm==1?'编辑':'新增'}}</div>
                        <div class="fl_right tandel" @click="tandel"></div>
                        <div class="clear"></div>
                    </div>
                    <div class="tancenter" style="height: 99%;overflow-y: auto;padding-bottom: 90px;">
                        <div class="list listpad">
                            <div class="fl_left name">头像</div>
                            <div class="fl_left inputBox">
                                <div class="file-list">
                                    <div class="urlLogo urlLogo1" >
                                        <img :src="avater_img" alt="" v-if="avater_img">
                                        <div class="add" v-if="!avater_img"></div>
                                        <input type="file" id="file1" multiple="false" @change="doUpload(1)"/>
                                    </div>
                                </div>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">姓名<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                            <div class="fl_left inputBox">
                                <Input v-model="addModel.name" class="bordiv" size="large" autocomplete="off" style="width:440px;" placeholder="请输入高教姓名" />
                                <input type="text"  autocomplete="off" name="" style="display:none">
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">性别<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                            <div class="fl_left inputBox">
                                <RadioGroup v-model="addModel.sex">
                                    <Radio label="1">男</Radio>
                                    <Radio label="0">女</Radio>
                                </RadioGroup>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">级别<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                            <div class="fl_left inputBox">
                                <Select v-model="addModel.level_id" class="bordiv" placeholder="请选择级别" filterable style="width:167px;margin-right:10px;height:36px;">
                                 <Option v-for="item in levelArr" :key="item.id" :value="item.id" >{{ item.name}}</Option>
                                </Select>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">等级</div>
                            <div class="fl_left inputBox">
                                <Select v-model="addModel.grade_id" placeholder="请选择等级" class="borDiv" style="width:167px;margin-right:10px;height:36px;">
                                    <Option v-for="item in gradeList" :value="item.id" :key="item.id">{{ item.grade }}</Option>
                                </Select>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">电话/登录账号<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                            <div class="fl_left inputBox">
                                <Input v-model="addModel.phone" class="bordiv" size="large" style="width:440px;" placeholder="请输入高教手机号" />
                                <input type="text" autocomplete="off" name="" style="display:none">
                                <div>登录账号初始密码为<span style="color:#c30d23;">000000</span></div>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">高教毕业院校<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                            <div class="fl_left inputBox">
                                <Input v-model="addModel.school" class="bordiv" size="large" style="width:440px;" placeholder="请输入高教毕业院校" />
                                <input type="text" autocomplete="off" name="" style="display:none">
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">高教介绍<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                            <div class="fl_left inputBox">
                                <Input v-model="addModel.describe" type="textarea" class="bordiv" size="large" style="width:440px;height:120px;" placeholder="请输入高教介绍"/>
                                <input type="text" autocomplete="off" name="" style="display:none">
                            </div>
                            <div class="clear"></div>
                        </div>
                    </div>
                    <div class="tabBtnBox">
                        <div class="tanBtn" @click="saveTeacher">确定</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'manage',
        data () {
            return {
                //搜索model
                searchModel:{
                    level_id:'',
                    keyword:'',
                    page:1,
                    grade_id:'',//等级ID
                },
                //添加model
                addModel:{
                    teacher_id:'',
                    name:'',
                    level_id:'',
                    phone:'',
                    sex:'0',
                    school:'',
                    describe:'',
                    avater:'',
                    grade_id:'',//等级ID
                },
                levelArr:[],
                teacher_id:'',
                total:null,
                pageSize:100,
                loading:false,
                stop_reason:'',
                columns7: [
                    {
                        title: '',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('div', [
                                h('Icon', {
                                    props: {
                                        type: 'ios-move'
                                    },
                                    style:{
                                      cursor: 'all-scroll'
                                    }
                                })
                            ])
                        }
                    },
                    {
                        title: '高教',
                        align: 'center',
                        key: 'name',
                        width:160,
                        render: (h, params) => {
                            if(params.row.sex==1){
                                return h('div',{
                                    style:{
                                        overflow:'hidden',
                                        padding:'10px 0'
                                    }
                                },[
                                    h('img',{
                                        style:{
                                            width:'47px',
                                            height:'60px',
                                            display:'block',
                                            float:'left'
                                        },
                                        domProps: {
                                            src:params.row.avater==''?'static/imgs/logo@3x.png':params.row.avater
                                        }
                                    }),
                                    h('div',{
                                        style:{
                                            width:'80px',
                                            float:'left',
                                            margin:'0px 0 0 11px'
                                        },
                                    },[
                                        h('div',{
                                            style:{
                                                width:'80px',
                                                overflow:'hidden'
                                            },
                                        },[
                                            h('div',{
                                                style:{
                                                    float:'left'
                                                }
                                            },params.row.name),
                                            h('div',{
                                                style:{
                                                    background:'url(static/imgs/man.png) left center / 12px no-repeat',
                                                    margin:'0 0 0 5px',
                                                    width:'12px',
                                                    height:'21px',
                                                    float:'left'
                                                }
                                            })
                                        ]),
                                        h('div',{
                                            style:{
                                                textAlign:'left'
                                            }
                                        },params.row.school),
                                    ])
                                ]);
                            }
                            else if(params.row.sex==0){
                                return h('div',{
                                    style:{
                                        overflow:'hidden',
                                        padding:'10px 0'
                                    }
                                },[
                                    h('img',{
                                        style:{
                                            width:'47px',
                                            height:'60px',
                                            display:'block',
                                            float:'left'
                                        },
                                        domProps: {
                                            src:params.row.avater==''?'static/imgs/logo@3x.png':params.row.avater
                                        }
                                    }),
                                    h('div',{
                                        style:{
                                            width:'80px',
                                            float:'left',
                                            margin:'0px 0 0 11px'
                                        },
                                    },[
                                        h('div',{
                                            style:{
                                                width:'80px',
                                                overflow:'hidden'
                                            },
                                        },[
                                            h('div',{
                                                style:{
                                                    float:'left'
                                                }
                                            },params.row.name),
                                            h('div',{
                                                style:{
                                                    background:'url(static/imgs/girl.png) left center / 10px no-repeat',
                                                    margin:'0 0 0 5px',
                                                    width:'12px',
                                                    height:'21px',
                                                    float:'left'
                                                }
                                            })
                                        ]),
                                        h('div',{
                                            style:{
                                                textAlign:'left'
                                            }
                                        },params.row.school),
                                    ])
                                ]);
                            }
                        }
                    },
                    {
                        title: '高教介绍',
                        align: 'center',
                        key: 'describe',
                        render: (h, params) => {
                            return h('div',{
                                // style:{
                                //     color:'#999',
                                // }
                            },params.row.describe===''?'--':params.row.describe);
                        }
                    },
                    {
                        title: '级别',
                        align: 'center',
                        key: 'level',
                    },
                    {
                        title: '等级',
                        align: 'center',
                        key: 'grade',
                    },
                    {
                        title: '联系电话/登录账号',
                        align: 'center',
                        key: 'phone',
                    },
                    {
                        title: '状态',
                        align: 'center',
                        key: 'status',
                        render: (h, params) => {
                            if(params.row.is_stop==1){
                                return h('div',{
                                    style:{
                                        color:'#999',
                                    }
                                },'已停用');
                            }
                            else if(params.row.is_stop==0){
                                return h('div',{
                                    style:{
                                        color:'#49c00e',
                                    }
                                },'正常');
                            }
                        }
                    },{
                        title: 'APP是否显示',
                        align: 'center',
                        key: 'is_formal',
                        render: (h, params) => {
                            let _this = this
                            return h('div',[
                                h('i-switch', {
                                    props: {
                                        value: params.row.is_formal==1, 
                                        size:'default',
                                        disabled:this.disabled,
                                    },
                                    nativeOn: { 
                                        click:() => { //值发生了改变调用方法
                                            this.$axios.post('showtoapp',{user_id:params.row.id}).then(res=>{
                                                if(res.data.code==200){
                                                    this.getTeacherList(0)
                                                    this.$Message.success('操作成功');
                                                 }
                                                 else{
                                                     this.$Message.error(res.data.message);
                                                     this.getTeacherList(0)
                                                 }
                                            }).catch(function (error) {
                                                console.log(error);
                                            });
                                        }
                                    }
                                },
                                [
                                    h('span',{
                                        slot:'open',
                                        domProps:{
                                            innerHTML:'是'
                                        }, 
                                    }),
                                    h('span',{
                                        slot:'close',
                                        domProps:{
                                            innerHTML:'否'
                                        }, 
                                    })
                                ])
                            ]);
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'bespeak_count',
                        render: (h, params) => {
                            // if(params.row.status==0){
                                return h('div', [
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                            marginRight:'10px'
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                _this.teacher_id    = params.row.id;
                                                _this.addModel      = params.row;
                                                _this.addModel.sex      = params.row.sex+'';
                                                _this.avater_img    = params.row.avater;
                                                _this.valm=1;
                                                _this.alertShow=true;
                                                _this.stop();
                                            }
                                        }
                                    }, '编辑'),
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                            margin:'0 5px',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                if(params.row.is_stop==0){
                                                    this.stop_reason='';
                                                    this.$Modal.confirm({
                                                        render: (h) => {
                                                            return h('Input', {
                                                                props: {
                                                                    value: this.stop_reason,
                                                                    autofocus: true,
                                                                    placeholder: '请输入停用该高教的原因'
                                                                },
                                                                style:{
                                                                    border:'1px solid #dcdcdc'
                                                                },
                                                                on: {
                                                                    input: (val) => {
                                                                        this.stop_reason = val;
                                                                    }
                                                                }
                                                            })
                                                        },
                                                        onOk: () => {
                                                            if(this.stop_reason===''){
                                                                this.$Message.error('请输入停用该高教的原因');
                                                            }
                                                            else{
                                                                this.$axios.post('changeteacherstop',{
                                                                    teacher_id:params.row.id,
                                                                    stop_reason:this.stop_reason
                                                                }).then(res=>{
                                                                    if(res.data.code==200){
                                                                        this.data6=[];
                                                                        this.getTeacherList(0)
                                                                     }
                                                                     else{
                                                                         this.$Message.error(res.data.message);
                                                                         // this.disabled=true;
                                                                         this.getTeacherList(0)
                                                                     }
                                                                }).catch(function (error) {
                                                                  console.log(error);
                                                                });
                                                            }
                                                        },
                                                        onCancel: () => {
                                                            this.data6=[];
                                                            this.stop_reason='';
                                                            this.getTeacherList(0)
                                                        }
                                                    })
                                                }
                                                else{
                                                    this.$Modal.confirm({
                                                        title: '停用原因：<span style="color:#c30d23;">'+params.row.stop_reason+'</span>',
                                                        content: '<p>确定要启用该高教？</p>',
                                                        okText: '确定',
                                                        cancelText: '取消',
                                                        onOk: () => {
                                                            _this.$axios.post('changeteacherstop',{
                                                                teacher_id:params.row.id
                                                            }).then(res=>{
                                                                if(res.data.code==200){
                                                                    _this.$Message.success('操作成功');
                                                                    _this.data6=[];
                                                                    _this.getTeacherList(0);
                                                                 }
                                                                 else{
                                                                     this.$Message.error(res.data.message);
                                                                 }
                                                            }).catch(function (error) {
                                                              console.log(error);
                                                            });
                                                        },
                                                        onCancel: () => {
                                                            // this.$Message.info('取消');
                                                        }
                                                    });
                                                }
                                            }
                                        }
                                    }, params.row.is_stop==0?'停用':'启用'),
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                this.$Modal.confirm({
                                                    title: '提示',
                                                    content: '<p>确定要删除这个高教？</p>',
                                                    okText: '确定',
                                                    cancelText: '取消',
                                                    onOk: () => {
                                                        _this.$axios.post('deleteteacher',{teacher_id:params.row.id}).then(res=>{
                                                            if(res.data.code==200){
                                                                _this.$Message.success('删除成功');
                                                                _this.getTeacherList(0);
                                                             }
                                                             else{
                                                                 this.$Message.error(res.data.message);
                                                             }
                                                        }).catch(function (error) {
                                                          console.log(error);
                                                        });
                                                    },
                                                    onCancel: () => {
                                                        // this.$Message.info('取消');
                                                    }
                                                });
                                            }
                                        }
                                    }, '永久删除'),
                                ]);
                            // }
                        }
                    }
                ],
                data6: [],
                alertShow:false,
                valm:0,
                avater_img:'',
                gradeList:[], //级别列表
            }
        },
        methods:{
            stop(){
                var mo=function(e){e.preventDefault();};
                document.body.style.overflow='hidden';
                document.addEventListener("touchmove",mo,false);//禁止页面滑动
            },
            move(){
                var mo=function(e){e.preventDefault();};
                document.body.style.overflow='';//出现滚动条
                document.removeEventListener("touchmove",mo,false);
            },
            //只修改 form 和 to之间的排序
            setWorkSort(form, to) {
                form   = parseInt(form)
                to     = parseInt(to)
     
                let tmp = this.data6[form]

                //重置排序
                this.sortData   = [];
                //向上冒泡
                if(form < to) {
                    for(var i=form+1; i<=to; i++) {
                        this.data6.splice(i-1, 1, this.data6[i])
                        this.sortData.push({user_id:this.data6[i].id,tsort:i})
                    }
                    this.data6.splice(to, 1, tmp)
                    this.sortData.push({user_id:tmp.id,tsort:i})
                }
                //向下浮沉
                if(form > to) {
                    for(var i=form; i>to; i--) {
                        this.data6.splice(i, 1, this.data6[i-1])
                        this.sortData.push({user_id:this.data6[i-1].id,tsort:i})
                    }
                    this.data6.splice(to, 1, tmp)
                    this.sortData.push({user_id:tmp.id,tsort:i})
                }

                this.$axios.post('sortteacher', {sort_data:this.sortData}).then(res => {
                    if (res.data.code == 200) {
                        this.$Message.success("排序成功");
                    }
                    else {
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //二进制转换
            toBlob(urlData,fileType){
                var bytes=window.atob(urlData),
                    n=bytes.length,
                    u8arr=new Uint8Array(n);
                while(n--){
                    u8arr[n]=bytes.charCodeAt(n);
                }
                return new Blob([u8arr],{type:fileType});
            },
            random_string(len) {
                len = len || 32;
                var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
                var maxPos = chars.length;
                var pwd = "";
                for (var i = 0; i < len; i++) {
                    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
                } 
                return pwd;
            },
            //点击上传图片事件
            doUpload(index){
                let _this = this;
                _this.clnum=index;
                if(index==1){
                    var files = document.getElementById('file1');
                    var fileLen = document.getElementById('file1').files;
                    var filename=$('#file1').val();
                    // _this.uploadByOss(fileLen[0])
                    // _this.option.autoCropWidth=241;//截图框宽
                    // _this.option.autoCropHeight=337;//截图框高
                    // _this.option.img=URL.createObjectURL(fileLen[0]);
                    // _this.cropShow=true;
                    _this.avater_img=URL.createObjectURL(fileLen[0]);
                    _this.uploadByOss(fileLen[0])
                    $('#file1').val('')
                }
            },
            //阿里云上传
            uploadByOss(file){
                let _this = this;
                const loading = this.$loading({
                    lock: true,
                    text: '加载中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                var fileurl =new Date().getTime() + _this.random_string(16)+'.'+file.name.split('.')[1]
                return new Promise(function(resolve , reject){  // Promise 一定要在函数的最外层才有效
                    _this.$axios.post('policyaction').then(function(res){
                         var re = res.data.data;
                         var osssignature = {
                            'key' : re.dir+fileurl,
                            'policy': re.policy,
                            'OSSAccessKeyId': re.accessid,
                            'success_action_status' : '200', 
                            'signature': re.signature,
                            'callback':re.callback,
                        };
                        var formData = new FormData()
                        for( var k in osssignature ){
                            formData.append(k, osssignature[k])
                        }
                        //var suffix = _this.get_suffix(file.type); // 获取文件扩展名
                        formData.append("key", re.dir);
                        formData.append('file', file)  // 必须放最后
                        var xhr = new XMLHttpRequest()
                        //xhr.upload.addEventListener('progress', uploadProgress, false)
                        xhr.open('POST', re.host, true)
                        xhr.send(formData)
                        xhr.onload = () => {
                            if (xhr.status === 200 || xhr.status === 304) {
                                loading.close();
                                _this.addModel.avater = xhr.responseURL + re.dir + fileurl;
                            } else {
                                console.log(`error：error code ${xhr.status}`)
                            }
                        }             
                    })
                })
            }, 
            
            tandel(){
                this.alertShow=false;
                this.move();
            },
            //获取教师列表
            getTeacherList(index){
                let _this=this;
                if(index==1){
                    _this.searchModel.page=1;
                }
                _this.$axios.post('getteacherlist',_this.searchModel).then(res=>{
                    if(res.data.code==200){
                        _this.total=res.data.data.total;
                        _this.data6=res.data.data.list;
                        _this.loading=false;
                    }
                    else{
                        _this.loading=false;
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            updatePage(num) {
                this.searchModel.page = num;
                this.getTeacherList(0);
            },
            //添加教师
            addTeacher(){
                let _this=this;
                _this.valm=0;
                _this.addModel = {
                    teacher_id:'',
                    name:'',
                    level_id:'',
                    phone:'',
                    sex:'0',
                    school:'',
                    describe:'',
                    avater:'',
                    grade_id:'',//等级ID
                };
                _this.alertShow=true;
                _this.stop();
            },
            //保存教师
            saveTeacher(){
                let _this=this;
                let pattern=/^1[3456789]\d{9}$/;//手机号验证
                let patternemail = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                if(_this.addModel.name==''){
                    this.$Message.error('请输入高教姓名');
                }
                else if(_this.level_id==''){
                    this.$Message.error('请选择级别');
                }
                else if(_this.phone==''){
                    this.$Message.error('请输入手机号');
                }
                else if(pattern.test(_this.addModel.phone)==false){
                    this.$Message.error('手机号输错了');
                }
                else if(_this.addModel.school==''){
                    this.$Message.error('请输入高教毕业院校');
                }
                else if(_this.addModel.describe==''){
                    this.$Message.error('请输入高教相关描述文字');
                }
                else{
                    let _url    = '';
                    if(_this.valm == 0){
                        _url = "addteacher";
                    }else{
                        _url = "editteacher";
                        _this.addModel.teacher_id = _this.teacher_id;
                    }
                    _this.$axios.post(_url,_this.addModel).then(res=>{
                        if(res.data.code==200){
                            _this.alertShow=false;
                            _this.getTeacherList(0);
                            _this.move();
                        }
                        else{
                            this.$Message.error(res.data.message);
                            _this.move();
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            },
            //获取级别
            getLevelList(){
                let _this=this; 
                _this.$axios.post('getlevellist',{}).then(res=>{
                    if(res.data.code==200){
                        _this.levelArr=res.data.data;
                    }
                    else{
                        _this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            //获取等级
            getGrade(){
                let _this=this; 
                _this.$axios.post('getgrade',{}).then(res=>{
                    if(res.data.code==200){
                        _this.gradeList = res.data.data;
                    }
                    else{
                        _this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
        },
        created(){
            let _this=this; 
            _this.getLevelList();
            _this.getGrade();
            _this.getTeacherList(1);
        }
    }
</script>

<style scoped>
/**/
    .selVox{
        overflow: hidden;
        height: 80px;
        line-height: 80px;
    }
/**/
    .tabBtnBox{
        height: 56px;
        padding-top: 10px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: #fff;
        box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.2);
        z-index: 99;
    }
    .urlLogo{
        width: 150px;
        height: 210px;
        /*background: #f5f5fa url('../../../static/imgs/baadd.png') center center/30px no-repeat;*/
        border: solid 1px #e5e5e5;
        position: relative;
        overflow: hidden;
    }
    .urlLogo input{
        position: absolute;
        top:0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0;
    }
    .urlLogo img{
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
        /*z-index: 999;*/
    }
    .borDiv{
        border: 1px solid #e7e7eb;
        border-radius: 4px;
        overflow: hidden;
        width: 290px;
    }
    .name{
        line-height: 36px;
        text-align: right;
        color: #333;
        margin-right: 16px;
        width: 135px;
    }
    .wzbarBox{
      /* width: 134px; */
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      align-items:center;
      height: 58px;
    }
    .wzbar{
      color: #999;
      display: flex;
      display: -webkit-flex;
      align-items:center;
      flex-direction:column;
      line-height: 58px;
      cursor: pointer;
      margin-right: 20px;
    }
    .wzbar>span{
      display: block;
      width: 55px;
      height: 3px;
      background-color: #f6f6f6;
    }
    .wzbars{
      color: #c30d23;
    }
    .wzbars>span{
      background-color: #c30d23;
    }
    .title{
        line-height: 68px;
        color: #303030;
        font-size: 18px;
    }
    .content,#manage{
        width: 100%;
    }
    .botBox{
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        padding-bottom: 20px;
        min-height: 785px;
        position: relative;
        border:1px solid #e6e6e6;
    }
    .center,.bottomBox{
        padding: 0 20px;
        box-sizing: border-box;
    }
    .top,.center,.bottom,.bottomBox{
        width: 100%;
    }
    .top{
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #e6e6e6;
        padding: 0 20px;
        box-sizing: border-box;
        position: relative;
        margin-bottom: 25px;
    }
    .showBox{
        position: absolute;
        right: 20px;
        top:65px;
        z-index: 99;
    }
    .shdawBot{
        padding: 0 30px 15px;
        box-sizing: border-box;
    }
    .addClass{
        width: 132px;
        height: 36px;
        border-radius: 2px;
        background-color: #c30d23;
        color: #fff;
        line-height: 36px;
        text-align: center;
        margin-top: 22px;
        cursor: pointer;
    }
    .add {
        width: 150px;
        height: 210px;
        float: left;
        cursor: pointer;
        background: url(../../../static/imgs/up_zjzs.png) center center /100% no-repeat;  /*// 这里使用的是我本地图片*/
    }
</style>



// WEBPACK FOOTER //
// src/components/user_mager/tea.vue